import React, { Component } from 'react';
import styled from 'styled-components';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  ButtonToolbar,
  Tag,
  IconButton,
  Icon,
  Input,
  InputGroup,
  HelpBlock
} from 'rsuite';

const map = fp.map.convert({ cap: false });

const TagGroup = styled.div`
  padding: 10px 0;
`;

export default class InventoryAddTagsModal extends Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    isSaving: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      typing: true,
      inputValue: '',
      tags: []
    };
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputConfirm = this.handleInputConfirm.bind(this);
  }

  handleOnShow = () => {
    this.setState({ tags: [] });
  };

  handleSubmit = () => {
    const { onSubmit } = this.props;
    const { tags } = this.state;
    onSubmit(tags);
  };

  handleButtonClick() {
    this.setState({ typing: true }, () => {
      if (this.input) this.input.focus();
    });
  }

  handleInputChange(inputValue) {
    this.setState({ inputValue });
  }

  handleInputConfirm() {
    const { inputValue, tags } = this.state;
    const nextTags = inputValue ? [...tags, inputValue] : tags;
    this.setState({
      tags: nextTags,
      typing: false,
      inputValue: ''
    });
    this.handleButtonClick();
  }

  handleTagRemove(tag) {
    const { tags } = this.state;
    const nextTags = tags.filter(item => item !== tag);
    this.setState({
      tags: nextTags
    });
  }

  renderInput() {
    const { typing, inputValue } = this.state;

    if (typing) {
      return (
        <InputGroup>
          <Input
            inputRef={ref => {
              this.input = ref;
            }}
            placeholder="Type tag here"
            style={{ display: 'inline', paddingLeft: 10 }}
            value={inputValue}
            onChange={this.handleInputChange}
            onBlur={this.handleInputConfirm}
            onPressEnter={this.handleInputConfirm}
          />
          <InputGroup.Button
            style={{ borderBottom: 'none' }}
            disabled={!inputValue}
          >
            <Icon icon="plus" />
          </InputGroup.Button>
        </InputGroup>
      );
    }
    return (
      <IconButton
        onClick={this.handleButtonClick}
        icon={<Icon icon="plus" />}
        appearance="ghost"
        size="xs"
      />
    );
  }

  render() {
    const { tags } = this.state;
    const { show, onHide, isSaving } = this.props;
    return (
      <Modal
        overflow
        size="xs"
        show={show}
        onShow={this.handleOnShow}
        onHide={onHide}
      >
        <Modal.Header>
          <Modal.Title>Add Multiple Tags</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ marginTop: 10 }}>
          {this.renderInput()}
          <HelpBlock style={{ margin: 3 }}>
            <small>
              <Icon icon="info" /> Click + or press enter to add tag
            </small>
          </HelpBlock>
          <TagGroup>
            {map(
              (item, index) => (
                <Tag
                  style={{ marginRight: 10, marginLeft: 0, marginBottom: 10 }}
                  key={index}
                  closable
                  onClose={() => {
                    this.handleTagRemove(item);
                  }}
                >
                  {item}
                </Tag>
              ),
              tags
            )}
          </TagGroup>
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar style={{ float: 'right' }}>
            <Button
              onClick={this.handleSubmit}
              appearance="primary"
              disabled={isSaving}
            >
              {isSaving ? 'Saving...' : 'Save'}
            </Button>
            <Button onClick={onHide}>Cancel</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    );
  }
}
